<template>
  <b-card>
    <div v-if="from === 'adminCedente'">
      <div class="d-flex justify-content-between align-items-center mb-1" v-if="!showInviteForm">
        <h3 class="mb-0 mr-1">Convites</h3>
        <b-button variant="primary" @click="showInviteForm = true">
          <span class="mb-0 text-dark font-weight-bolder"> Criar convite </span>
        </b-button>
      </div>

      <invite-form v-else @closeForm="closeInviteForm" :from="from" />

      <b-card class="card-cs-border card-cs-bg p-1 mb-0" v-if="!showInviteForm && !invites?.length">
        <div class="d-flex align-items-center">
          <b-img src="@/assets/images/admin/invites-empty-state.svg" width="100" class="mr-2" />
          <div class="d-flex flex-column">
            <h4>Nenhum convite foi criado até momento.</h4>
            <span>Crie um convite de cadastro agora.</span>
          </div>
        </div>
      </b-card>
    </div>

    <datatable
      v-if="serviceUrl"
      no-body
      ref="inviteDatatable"
      :customActions="customActions"
      :customFields="inviteCustomFields"
      :serviceUrl="serviceUrl"
      :customFilters="customFilters"
      :customParams="datatableParams"
    >
      <template #table-header>
        <div class="d-flex justify-content-between">
          <div>
            <h3 class="mb-0"></h3>
            <b-button
              variant="light-info"
              class="bg-light-info border-info"
              @click="executaInBatch('enviar')"
            >
              <span class="mr-50 text-dark font-weight-bolder"> Enviar </span>
            </b-button>

            <b-button
              variant="light-danger"
              class="bg-light-danger border-danger ml-1"
              @click="executaInBatch('cancelar')"
            >
              <span class="mr-50 text-dark font-weight-bolder"> Excluir </span>
            </b-button>
          </div>

          <div>
            <feather-icon
              icon="FilterIcon"
              size="24"
              class="cursor-pointer text-secondary ml-1 float-right mb-1"
              @click="showFiltersButton = true"
            />
          </div>
        </div>
      </template>
    </datatable>

    <datatable-filters-handler-sidebar
      :is-task-handler-sidebar-active="showFiltersButton"
      @closeSideBar="showFiltersButton = false"
      @updateFilterValues="updateFilterValues"
      :filters="customFilters"
    />
  </b-card>
</template>

<script>
import { BImg, BCard, BBadge, BButton, BTooltip } from 'bootstrap-vue'
import InviteForm from '@/views/admin/assignor/components/InviteForm.vue'
import InviteCard from '@/views/admin/assignor/components/InviteCard.vue'
import Datatable from '@/views/common/crud/components/Datatable.vue'
import {
  brazilianFormattedDate,
  conviteStatusBadge,
} from '@core/comp-functions/data_visualization/datatable'
import DatatableFiltersHandlerSidebar from '@/views/common/crud/components/DatatableFiltersHandlerSidebar.vue'
import http from '@/services/http'

export default {
  name: 'Invites',
  components: {
    BImg,
    BCard,
    BBadge,
    BButton,
    BTooltip,
    InviteCard,
    InviteForm,
    Datatable,
    DatatableFiltersHandlerSidebar,
  },
  props: {
    from: {
      type: String,
      default: 'default',
    },
  },
  data() {
    return {
      invites: [],
      showInviteForm: false,
      showFiltersButton: false,
      datatableFilterValues: {},
      serviceUrl: '',
      inviteCustomFields: [
        { label: '', key: 'select' },
        { label: 'Nome', key: 'nome' },
        { label: 'Celular', key: 'telefone' },
        { label: 'Data de envio', key: 'ultimo_envio', formatter: brazilianFormattedDate },
        { label: 'Email', key: 'email' },
        { label: 'Status', key: 'aceito', formatter: conviteStatusBadge },
      ],
      customFilters: [
        {
          category: 'Por parâmetro',
          fields: [
            { label: 'Nome', key: 'nome', type: 'text' },
            { label: 'Email', key: 'email', type: 'text' },
            { label: 'Date de envio', key: 'enviado', type: 'date' },
            {
              label: 'Status',
              key: 'aceito',
              type: 'select',
              options: [
                { value: 'true', label: 'Cadastro realizado' },
                { value: 'false', label: 'Aguardando cadastro' }
              ],
            },
          ],
        }
      ],
      customActions: [
        {
          label: 'Copiar link',
          icon: 'CopyIcon',
          action: 'copy',
          title: 'Click para copiar o link',
          action: (row) => {
            this.$copyText(row.url_convite);
          },
        },
      ],
    }
  },
  async created() {
    this.setServiceUrl()
  },
  async mounted() {
    await this.getData()
    if (this.$route.query.creating) this.showInviteForm = true
  },
  methods: {
    setServiceUrl() {
      switch (this.from) {
        case 'adminCedente':
          this.serviceUrl = '/admin/cedente/convites'
          break
        case 'adminInvestidor':
          this.serviceUrl = '/admin/investidor/convites'
          break
        case 'adminFornecedor':
          this.serviceUrl = '/admin/fornecedor/convites'
          break
        default:
          this.serviceUrl = ''
      }
    },
    closeInviteForm() {
      this.getData()
      this.showInviteForm = false
    },
    async getData() {
      const params = {
        cedente_grupo_economico_id: this.$route.params.id,
      }
      try {
        let dispatchUrl = ''
        switch (this.from) {
          case 'adminCedente':
            dispatchUrl = 'admin/fetchInvites'
            break
          case 'adminInvestidor':
            dispatchUrl = 'admin/fetchInvestorInvites'
            break
          case 'adminFornecedor':
            dispatchUrl = 'adminProvider/fetchInvites'
            break
        }

        if (dispatchUrl) {
          const { data } = await this.$store.dispatch(dispatchUrl, params)
          this.invites = data.data
        }
      } catch (error) {
        console.error("Erro ao buscar dados:", error)
      }
    },
    updateFilterValues(values) {
      this.datatableFilterValues = values
    },
    async executaInBatch(new_type) {
      let convites = this.$refs.inviteDatatable.selectedRows.map(row => row.id).join(', ')
      let emails = this.$refs.inviteDatatable.selectedRows.map(row => row.email).join(', ')

      if(this.$refs.inviteDatatable.selectedRows?.length === 0) {
        this.$swal({
          title: 'Nenhum convite selecionado!',
          text: 'Selecione ao menos um convite para executar uma ação.',
          icon: 'warning',
          confirmButtonText: 'Ok',
        })
        return
      } else {
        this.$swal({
          title: `Deseja ${new_type} os convites selecionados?`,
          text: `${new_type} convites para os emails: ${emails}.`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Confirmar',
          cancelButtonText: 'Cancelar',
        }).then((result) => {
          if(result.isConfirmed) {
            let baseUrlAction = ''
            switch (this.from) {
              case 'adminCedente': baseUrlAction = '/admin/cedente'; break;
              case 'adminInvestidor': baseUrlAction = '/admin/investidor'; break;
              case 'adminFornecedor': baseUrlAction = '/admin/fornecedor'; break;
            }
            this.envioOuCancelamento(convites, new_type, baseUrlAction)
            
            this.$swal({
              title: 'Processo realizado!',
              text: `Convites processados com sucesso!`,
              icon: 'success',
              confirmButtonText: 'Ok',
            })
          }
        }).then(() => {
          this.$refs.inviteDatatable.refresh();
        })
      }
    },
    envioOuCancelamento(convites, new_type, url) {
      const endpoint = new_type === 'enviar' ? 'enviar_convites' : 'cancelar_convites'
      http.post(`${url}/convites/${endpoint}`, { ids: convites }).then(() => {
        this.$refs.inviteDatatable.refresh();
      })
    }
  },
  computed: {
    serviceUrl() {
      switch (this.from) {
        case 'adminCedente':
          return '/admin/cedente/convites'
        case 'adminInvestidor':
          return '/admin/investidor/convites'
        case 'adminFornecedor':
          return '/admin/fornecedor/convites'
        default:
          return ''
      }
    },
    datatableParams() {
      let params = {}

      // Adiciona o ID do grupo econômico baseado no tipo de portal
      if (this.from === 'adminCedente') {
        params.cedente_grupo_economico_id = this.$route.params.id
      } else if (this.from === 'adminFornecedor') {
        params.fornecedor_grupo_economico_id = this.$route.params.id
      }

      // Adiciona filtros personalizados se houver
      if (this.datatableFilterValues) {
        params = { ...params, ...this.datatableFilterValues }
      }

      return params
    },
    params() {
      let params = {}

      if (this.datatableFilterValues) params = { ...params, ...this.datatableFilterValues }

      return params
    },
  },
  watch: {
    params(newValue, oldValue) {
      if (newValue !== oldValue && this.$refs.inviteDatatable) {
        this.$refs.inviteDatatable.updateFilterValues(newValue)
      }
    },
  },
}
</script>
